module.exports = __webpack_public_path__ + "img/hlw_images_.c1af33ae.png";